import type { App } from 'vue';
import router from '@/router/index.ts';
import { notify } from '@/plugins/vue-notification.ts';
import i18n from '@/plugins/vue-i18n.js';
import MfaAuth from './mfa-auth.ts';

/**
 * Creates and registers one MFA service instance.
 * MFA means Multi-Factor Authentication.
 * Wires router and notification dependencies at app startup.
 */
const mfaAuthService = new MfaAuth();

const VueMfaAuth = {
    install(app: App) {
        mfaAuthService.setDependencies({
            router,
            notify,
            translate: (key: string) => i18n.global.t(key),
        });

        app.config.globalProperties.$mfaAuth = mfaAuthService;
    },
};

export { mfaAuthService, VueMfaAuth };
export default VueMfaAuth;
